import React, { useState, useEffect, useRef } from 'react';
import { Heart, MessageCircle, ArrowDown, Eye, ArrowUp, TrendingUp, Flame, Award, Users, Clock, ChevronUp, ChevronDown, Share2, Bookmark, Filter, Search, Sparkles, Zap, Star, Trophy, Gift, Bell, Plus, X, Reply, MoreHorizontal, MessageSquare, UserCircle, RefreshCw } from 'lucide-react';
import API_URL from '../config/ApiUrl';
import { useTheme } from '../arrangement/ThemeContext';
export const TrendingCard = ({}) => {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState();
  const [lastUpdated, setLastUpdated] = useState(null);
  const { colors } = useTheme();
  // Fetch trending topics from API
  const fetchTrendingTopics = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/api/trending-topics`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();
      
      if (result.success && result.trending_topics) {
        setTopics(result.trending_topics.slice(0, 4));
        setLastUpdated(new Date());
      } else {
        // Fallback to default topics if API fails
        setTopics([
          { name: "Strain Reviews", count: 245, growth: "+12%", emoji: "🌿", color: "#00d4aa" },
          { name: "Growing Tips", count: 189, growth: "+8%", emoji: "🌱", color: "#10b981" },
          { name: "Edibles", count: 167, growth: "+15%", emoji: "🍪", color: "#d97706" },
          { name: "Concentrates", count: 134, growth: "+5%", emoji: "🔥", color: "#f59e0b" }
        ]);
      }
    } catch (error) {
      console.error('Error fetching trending topics:', error);
      // Fallback to default topics
      setTopics([
        { name: "Strain Reviews", count: 245, growth: "+12%", emoji: "🌿", color: "#00d4aa" },
        { name: "Growing Tips", count: 189, growth: "+8%", emoji: "🌱", color: "#10b981" },
        { name: "Edibles", count: 167, growth: "+15%", emoji: "🍪", color: "#d97706" },
        { name: "Concentrates", count: 134, growth: "+5%", emoji: "🔥", color: "#f59e0b" }
      ]);
    } finally {
      setLoading(false);
    }
  };

  // Auto-fetch if no topics provided as props
  useEffect(() => {

      fetchTrendingTopics();
      
      // Auto-refresh every 5 minutes
      const interval = setInterval(fetchTrendingTopics, 5 * 60 * 1000);
      return () => clearInterval(interval);

  }, []);

  // Manual refresh handler
  const handleRefresh = async () => {
    await fetchTrendingTopics();
  };

  if (loading) {
    return (
      <div style={{
        background: colors.comeCard,
        borderRadius: '16px',
        padding: '20px',
        border: '1px solid #333',
        marginBottom: '24px'
      }}>
        <h3 style={{
          margin: '0 0 16px 0',
          fontWeight: '600',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          color: '#e5e5e5'
        }}>
          <TrendingUp size={18} style={{ color: '#8b5cf6' }} />
          Loading Trending Topics...
        </h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {[...Array(4)].map((_, index) => (
            <div key={index} style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px',
              borderRadius: '12px',
              background: 'linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%)',
              border: '1px solid #333',
              opacity: 0.6
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{
                  width: '20px',
                  height: '20px',
                  background: '#333',
                  borderRadius: '4px'
                }} />
                <div>
                  <div style={{
                    width: '100px',
                    height: '14px',
                    background: '#333',
                    borderRadius: '4px',
                    marginBottom: '4px'
                  }} />
                  <div style={{
                    width: '60px',
                    height: '12px',
                    background: '#333',
                    borderRadius: '4px'
                  }} />
                </div>
              </div>
              <div style={{
                width: '40px',
                height: '20px',
                background: '#333',
                borderRadius: '12px'
              }} />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div style={{
      background: colors.comeCard,
      borderRadius: '16px',
      padding: '20px',
      border: '1px solid #333',
      marginBottom: '24px'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '16px'
      }}>
        <h3 style={{
          margin: 0,
          fontWeight: '600',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          color: '#e5e5e5'
        }}>
          <TrendingUp size={18} style={{ color: '#8b5cf6' }} />
          Trending Topics
        </h3>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {lastUpdated && (
            <span style={{
              fontSize: '10px',
              color: '#666',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}>
              <Clock size={10} />
              {lastUpdated.toLocaleTimeString()}
            </span>
          )}
          <button
            onClick={handleRefresh}
            style={{
              padding: '4px',
              background: 'transparent',
              border: '1px solid #333',
              borderRadius: '6px',
              color: '#888',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = '#8b5cf6';
              e.currentTarget.style.color = '#8b5cf6';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = '#333';
              e.currentTarget.style.color = '#888';
            }}
          >
            <RefreshCw size={12} />
          </button>
        </div>
      </div>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {topics.map((topic, index) => (
          <div key={index} style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '12px',
            borderRadius: '12px',
            background: colors.bgGradient,
            border: '1px solid #333',
            cursor: 'pointer',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)';
            e.currentTarget.style.borderColor = '#00d4aa';
            e.currentTarget.style.transform = 'translateX(4px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '';
            e.currentTarget.style.borderColor = '';
            e.currentTarget.style.transform = '';
          }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span style={{ fontSize: '20px' }}>{topic.emoji}</span>
              <div>
                <p style={{ margin: 0, fontWeight: '500', fontSize: '14px', color: '#e5e5e5' }}>
                  {topic.name}
                </p>
                <p style={{ margin: 0, fontSize: '12px', color: '#888' }}>
                  {topic.count} threads
                </p>
              </div>
            </div>
            <div style={{
              padding: '4px 8px',
              borderRadius: '12px',
              background: topic.color,
              color: 'white',
              fontSize: '11px',
              fontWeight: '600'
            }}>
              {topic.growth}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};